module.exports = __webpack_public_path__ + "static/mike-hancock-about.8010fcc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mike-hancock-about.jpg
// module id = 477
// module chunks = 263791100135453